import { render, staticRenderFns } from "./CreateNewBanner.vue?vue&type=template&id=4a6e730a&scoped=true"
import script from "./CreateNewBanner.vue?vue&type=script&lang=js"
export * from "./CreateNewBanner.vue?vue&type=script&lang=js"
import style0 from "./CreateNewBanner.vue?vue&type=style&index=0&id=4a6e730a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a6e730a",
  null
  
)

export default component.exports